import { Pipe, PipeTransform, NgZone, OnDestroy } from '@angular/core';
import i18next, { i18n } from 'i18next';
import { Subscription } from 'rxjs';
import { missingKeysLogger } from './i18n-missing-keys';


@Pipe({
  name: 'i18next',
  pure: false // IMPORTANT: so it updates when language changes
})
export class I18nextPipe implements PipeTransform, OnDestroy {

  private lastValue?: string;
  private lastKey?: string;
  private lastOptions?: any;
  private subscription?: Subscription;

  constructor(private zone: NgZone) {
    // Re-render when language changes
    i18next.on('languageChanged', this.handleLangChange);
  }

  transform(
    key: string | undefined | null,
    options?: any
  ): string {

    if (!key) {
      return '';
    }

    // Avoid unnecessary recomputation
    if (key === this.lastKey && this.shallowEqual(options, this.lastOptions)) {
      return this.lastValue ?? '';
    }

    this.lastKey = key;
    this.lastOptions = options;

    // Ask i18next for translation, but also check existence
    const exists = i18next.exists(key, options);

    if (!exists) {
      missingKeysLogger.markMissing(key);
      // return a visible fallback (choose one)
      // 1) show key: good in dev
      // this.lastValue = key;

      // 2) show empty string: less noisy in prod
      // this.lastValue = '';

      // 3) show bracketed key: very clear
      this.lastValue = `[${key}]`;
      return this.lastValue;
    }

    const value: string = i18next.t(key, options) as any;
    this.lastValue = value as string;

    return value;
  }

  private handleLangChange = (lng: string) => {
    // Optional: reset per-language dedupe if you want
    // missingKeysLogger.resetForLanguage(lng);

    // Force Angular to update bindings
    this.zone.run(() => {
      this.lastValue = undefined;
      this.lastKey = undefined;
      this.lastOptions = undefined;
    });
  };

  private shallowEqual(a: any, b: any): boolean {
    if (a === b) return true;
    if (!a || !b) return false;

    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(k => a[k] === b[k]);
  }

  ngOnDestroy(): void {
    i18next.off('languageChanged', this.handleLangChange);
  }
}
